import { ThemeConfig } from 'antd/es/config-provider/context'

export const token: ThemeConfig['token'] = {
  colorPrimary: '#bc8e5b',
}
